<template src="./index.html"></template>

<script>
import { inquiryAliasConfig, insertOrUpdateAliasConfig } from '../../../../../api/home.js';
import { getdata } from './data.js';
export default {
	name: 'AnalysisFieldName',
	data() {
		return {
			Datazfpz: {},
			/* 表格 */
			headData: getdata().headData,
			tableData: [
				{ test: '科目特殊标识1', specialIdentification: '' },
				{ test: '科目特殊标识2', specialIdentification: '' },
				{ test: '科目特殊标识3', specialIdentification: '' },
				{ test: '科目特殊标识4', specialIdentification: '' },
				{ test: '科目特殊标识5', specialIdentification: '' }
			],
			tablekey: 0,
			headDataqz: getdata().headDataqz,
			tableDataqz: [
				{ tcode: '分析代码1', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '分析代码2', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '分析代码3', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '分析代码4', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '分析代码5', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '分析代码6', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '分析代码7', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '分析代码8', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '分析代码9', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '分析代码10', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '参考字段1', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '参考字段2', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '参考字段3', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '参考字段4', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '参考字段5', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '参考字段6', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '参考字段7', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '参考字段8', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '参考字段9', tcoderef: '', tcodeWriteBalance: '' },
				{ tcode: '参考字段10', tcoderef: '', tcodeWriteBalance: '' }
			]
			/* 表格 */
		};
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		isNull(data){
			if(data == null || data == ''){
				return true;
			}
			return false;
		},
		preserve() {
			let params = this.Datazfpz;
			params.specialIdentification1 = this.tableData[0].specialIdentification;
			params.specialIdentification2 = this.tableData[1].specialIdentification;
			params.specialIdentification3 = this.tableData[2].specialIdentification;
			params.specialIdentification4 = this.tableData[3].specialIdentification;
			params.specialIdentification5 = this.tableData[4].specialIdentification;
			params.tcode1 = this.tableDataqz[0].tcoderef;
			params.tcode2 = this.tableDataqz[1].tcoderef;
			params.tcode3 = this.tableDataqz[2].tcoderef;
			params.tcode4 = this.tableDataqz[3].tcoderef;
			params.tcode5 = this.tableDataqz[4].tcoderef;
			params.tcode6 = this.tableDataqz[5].tcoderef;
			params.tcode7 = this.tableDataqz[6].tcoderef;
			params.tcode8 = this.tableDataqz[7].tcoderef;
			params.tcode9 = this.tableDataqz[8].tcoderef;
			params.tcode10 = this.tableDataqz[9].tcoderef;
			params.tcodeWriteBalance1 = this.tableDataqz[0].tcodeWriteBalance;
			params.tcodeWriteBalance2 = this.tableDataqz[1].tcodeWriteBalance;
			params.tcodeWriteBalance3 = this.tableDataqz[2].tcodeWriteBalance;
			params.tcodeWriteBalance4 = this.tableDataqz[3].tcodeWriteBalance;
			params.tcodeWriteBalance5 = this.tableDataqz[4].tcodeWriteBalance;
			params.tcodeWriteBalance6 = this.tableDataqz[5].tcodeWriteBalance;
			params.tcodeWriteBalance7 = this.tableDataqz[6].tcodeWriteBalance;
			params.tcodeWriteBalance8 = this.tableDataqz[7].tcodeWriteBalance;
			params.tcodeWriteBalance9 = this.tableDataqz[8].tcodeWriteBalance;
			params.tcodeWriteBalance10 = this.tableDataqz[9].tcodeWriteBalance;

			params.ref1 = this.tableDataqz[10].tcoderef;
			params.ref2 = this.tableDataqz[11].tcoderef;
			params.ref3 = this.tableDataqz[12].tcoderef;
			params.ref4 = this.tableDataqz[13].tcoderef;
			params.ref5 = this.tableDataqz[14].tcoderef;
			params.ref6 = this.tableDataqz[15].tcoderef;
			params.ref7 = this.tableDataqz[16].tcoderef;
			params.ref8 = this.tableDataqz[17].tcoderef;
			params.ref9 = this.tableDataqz[18].tcoderef;
			params.ref10 = this.tableDataqz[19].tcoderef;
			insertOrUpdateAliasConfig(params).then(res => {
				if (res.data.code == '200') {
					this.searrchForData();
					this.$message.success('保存成功');
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		searrchForData() {
			inquiryAliasConfig().then(res => {
				if (res.data.code == '200') {
					this.Datazfpz = res.data.data;
					for (var i = 0; i < 5; i++) {
						if(this.isNull(res.data.data['specialIdentification'+(i+1)]) ){
							this.tableData[i].specialIdentification = this.tableData[i].test;
						}else{
							this.tableData[i].specialIdentification = res.data.data['specialIdentification'+(i+1)];
						}
					}
					for (var i = 0; i < 10; i++) {
						if(this.isNull(res.data.data['tcode'+(i+1)])){
							this.tableDataqz[i].tcoderef = this.tableDataqz[i].tcode;
						}else{
							this.tableDataqz[i].tcoderef = res.data.data['tcode'+(i+1)];
						}
						if(this.isNull(res.data.data['tcodeWriteBalance'+(i+1)])){
							this.tableDataqz[i].tcodeWriteBalance = '0';
						}else{
							this.tableDataqz[i].tcodeWriteBalance = res.data.data['tcodeWriteBalance'+(i+1)];
						}
						if(this.isNull(res.data.data['ref'+(i+1)])){
							this.tableDataqz[i+10].tcoderef = this.tableDataqz[i+10].tcode;					
						}else{
							this.tableDataqz[i+10].tcoderef = res.data.data['ref'+(i+1)];
						}
					}
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
